import React, { useEffect, useState } from 'react';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Accordion,
  AccordionSummary,
  Box,
} from '@mui/material';
import WfhQuotaAccordian from './WfhQuotaAccordian';
import LeavesQuotaAccordian from './LeavesQuotaAccordian';
import { getUserData } from '../../../../services/UserService';
import { SHOW_NOTIFICATION } from '../../../../constants';
import { useDispatch } from 'react-redux';
import EmployeePrivilegeUpdate from '../EmployeePrivilegeUpdate';
import ExternalQuotaAccordian from './ExtrenalQuotaAccordian';

const QuotaCardComponents = (props) => {
  const [expanded, setExpanded] = useState(false);
  const [show, setShow] = useState(true);
  const [user, setUser] = useState({});
  const dispatch = useDispatch();

  const { data, type, selected } = props;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const loadUserDetails = async (id) => {
    const response = await getUserData(id);
    if (response.isError === false) {
      setUser(response.data);
    }
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const isWideScreen = windowWidth >= 992;

  useEffect(() => {
    if (type === 'leave') {
      loadUserDetails(data[0].employeeId);
    } else {
      loadUserDetails(data.employeeId);
    }
    setExpanded(false);
  }, [data, type]);

  useEffect(() => {
    if (user.firstName !== undefined) {
      let str = '' + user.firstName;
      str += user?.lastName ? ' ' + user?.lastName : '';
      if (str.toLowerCase().startsWith(selected.toLowerCase())) setShow(true);
      else setShow(false);
    }
  }, [selected]);

  return (
    <Card variant="outlined" sx={{ mb: 2, display: show ? 'block' : 'none' }}>
      <Grid container className="space-between-container p-3">
        <Grid>
          <Typography sx={{ mb: 1 }} variant="h5">
            {type === 'wfh'
              ? data.employeeName
              : user.firstName + (user.lastName ? ' ' + user.lastName : '')}
          </Typography>
          <Typography>
            {type === 'wfh'
              ? 'Employee Code :- ' + data.employeeCode
              : 'Employee Code :- ' + user.employeeCode}
          </Typography>
        </Grid>
        <Grid
          className="space-between-container"
          sx={{ flexDirection: { sm: 'column', md: 'row' } }}
        >
          {type === 'leave' && (
            <Grid>
              <EmployeePrivilegeUpdate user={user} />
            </Grid>
          )}
          {type === 'external' && (
            <Grid>
              <EmployeePrivilegeUpdate
                user={user}
                privilegeKey="REQUEST_EXTERNAL_HOURS"
                label="Request External Hours"
              />
            </Grid>
          )}
          {type === 'clientOffice' && (
            <Grid>
              <EmployeePrivilegeUpdate
                user={user}
                privilegeKey="REQUEST_CLIENT_OFFICE_HOURS"
                label="Request Client Office Hours"
              />
            </Grid>
          )}
          {type === 'workTravel' && (
            <Grid>
              <EmployeePrivilegeUpdate
                user={user}
                privilegeKey="REQUEST_WORK_TRAVEL_HOURS"
                label="Request Work Travel Hours"
              />
            </Grid>
          )}
          <Grid>
            <Box
              sx={{
                width: isWideScreen ? '20rem' : '100%',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              <Typography sx={{ mb: 1 }} variant="h6">
                {type === 'wfh' ? data.designation : user.designation}
              </Typography>
              <Typography>
                {'Email :- '}
                {type === 'wfh' ? data.email : user.emailId}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      <CardContent
        sx={{ padding: '0px', '&:last-child': { paddingBottom: 0 } }}
      >
        <div>
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            disableGutters
            elevation={0}
            sx={{ width: '100%', pt: 0, pb: 0 }}
          >
            <Grid
              className="pb-0 pt-0"
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <AccordionSummary
                sx={{ flexDirection: 'column', alignItems: 'center' }}
              >
                <Typography>
                  {type === 'wfh' && 'Quaterly WFH Quota Summary (in Days)'}
                  {type === 'leave' && 'Leaves Quota Summary'}
                  {type === 'external' && 'External Hours Quota Summary'}
                  {type === 'clientOffice' &&
                    'Client Office Hours Quota Summary'}
                  {type === 'workTravel' &&
                    'Work Travel Hours Quota Summary'}
                </Typography>
                <Box component={'span'}>
                  {!expanded ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                </Box>
              </AccordionSummary>
            </Grid>
            {type === 'wfh' && <WfhQuotaAccordian data={data} />}
            {type === 'leave' && (
              <LeavesQuotaAccordian
                data={data}
                leaveGroupId={user?.leaveGroupId}
                leaveGroupHydrationFailed={user?.leaveGroupHydrationFailed}
              />
            )}
            {type === 'external' && <ExternalQuotaAccordian data={data} />}
            {type === 'clientOffice' && (
              <ExternalQuotaAccordian data={data} quotaKey="clientOfficeHoursQuota" />
            )}
            {type === 'workTravel' && (
              <ExternalQuotaAccordian data={data} quotaKey="workTravelHoursQuota" />
            )}
          </Accordion>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuotaCardComponents;
